<template>
  <div class="info-container">
    <div class="left">
      <span class="headline">Customer information</span>
      <span class="sub-headline">Contact information</span>
      <div class="info-item">{{ this.$store.state.subscription.email }}</div>
    </div>
    <div class="right">
      <span class="sub-headline">Billing address</span>
      <div class="info-item">
        {{ this.$store.state.subscription.company }}
      </div>
      <div class="info-item">
        {{ this.$store.state.subscription.firstname }}
        {{ this.$store.state.subscription.lastname }}
      </div>
      <div class="info-item">
        {{ this.$store.state.subscription.street }}
        {{ this.$store.state.subscription.house_number }}
      </div>
      <div class="info-item">
        {{ this.$store.state.subscription.zip }}
        {{ this.$store.state.subscription.city }}
      </div>
      <div class="info-item">
        {{ this.$store.state.subscription.country_name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "info-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.info-container {
  display: flex;
  margin-top: 15px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 15px;
}

.info-container .left {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
}
.info-container .right {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
}

.left .headline {
  margin-bottom: 25px;
  font-size: 18px;
  height: 20px;
}
.left .sub-headline {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 13px;
}
.right .sub-headline {
  font-weight: bold;
  font-size: 15px;
  margin-top: 45px;
  margin-bottom: 13px;
}

.bold {
  font-weight: bold;
}

.info-item {
  font-size: 14px;
  margin-bottom: 8px;
}
</style>
